import React, { useContext, useEffect, useState } from "react";
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

import { AccountContext } from "@context/AccountProvider";
import { hasEqualOrHigherRole, Roles } from "@service/roleService";

export class ClubSiteTargetObject {
    constructor(club_uuid, site_uuid) {
        this.club_uuid = club_uuid;
        this.site_uuid = site_uuid;
    }

    equals(other) {
        if (!(other instanceof ClubSiteTargetObject)) {
            return false;
        }

        return this.club_uuid === other.club_uuid && 
               this.site_uuid === other.site_uuid;
    }
}

export function SelectClubSiteTarget({ target, setTarget, sx }) {
    const { t } = useTranslation(["main"]);
    const { club, sites, role } = useContext(AccountContext);
    
    const [availableClubs, setAvailableClubs] = useState([]);
    const [availableSites, setAvailableSites] = useState([]);
    
    useEffect(() => {
        if (hasEqualOrHigherRole(role, Roles.CLUB_EMPLOYEE)) {
            setAvailableClubs([club]);
        }
        if (hasEqualOrHigherRole(role, Roles.SITE_ADMIN)) {
            setAvailableSites(sites);
        }
    }, [club, sites, role]);
    
    const getSelectValue = () => {
        if (target.club_uuid) return `club-${target.club_uuid}`;
        if (target.site_uuid) return `site-${target.site_uuid}`;
        return '';
    };
    
    const handleTargetChange = (event) => {
        const value = event.target.value;
        if (value.startsWith('club-')) {
            const clubUuid = value.replace('club-', '');
            setTarget(new ClubSiteTargetObject(clubUuid, null));
        } else if (value.startsWith('site-')) {
            const siteUuid = value.replace('site-', '');
            setTarget(new ClubSiteTargetObject(null, siteUuid));
        } else {
            setTarget(new ClubSiteTargetObject(null, null));
        }
    };
    
    return (
        <Box sx={{...sx}}>
            <FormControl fullWidth>
                <InputLabel sx={{top:'-5px'}}>{t("selectTarget")}</InputLabel>
                <Select
                    value={getSelectValue()}
                    onChange={handleTargetChange}
                    label={t("selectTarget")}
                    required
                >                    
                    {availableClubs.length > 0 && (
                        <MenuItem disabled>{t("selectClub")}</MenuItem>
                    )}
                    {availableClubs.map(club => (
                        <MenuItem 
                            key={`club-${club.uuid}`} 
                            value={`club-${club.uuid}`}
                        >
                            {club.name}
                        </MenuItem>
                    ))}
                    
                    {availableSites.length > 0 && (
                        <MenuItem disabled>{t("selectSite")}</MenuItem>
                    )}
                    {availableSites.map(site => (
                        <MenuItem 
                            key={`site-${site.uuid}`}
                            value={`site-${site.uuid}`}
                        >
                            {site.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}